import { render } from "./VvBottomNavigation.vue?vue&type=template&id=f26f0cc6&scoped=true"
import script from "./VvBottomNavigation.vue?vue&type=script&lang=js"
export * from "./VvBottomNavigation.vue?vue&type=script&lang=js"

import "./VvBottomNavigation.vue?vue&type=style&index=0&id=f26f0cc6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f26f0cc6"]])

export default __exports__